module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LV - Latvia.5cda94d4.svg";